import React from "react";
import useI18n from "./hooks/useI18n.js";
import { useParams } from "react-router-dom";
import { ExitIcon } from "@100mslive/react-icons";
import {
  Box,
  Button,
  Flex,
  Text,
  textEllipsis,
} from "@100mslive/roomkit-react";
import { ToastManager } from "./Toast/ToastManager";
import { Header } from "./Header";
import { useNavigation } from "./hooks/useNavigation";
import {
  defaultPreviewPreference,
  UserPreferencesKeys,
  useUserPreferences,
} from "./hooks/useUserPreferences";

const PostLeave = () => {
  React.useEffect(() => {
    try {
      const searchParams = new URLSearchParams(window.location.search);
      const authToken = searchParams.get("auth_token");
      if (authToken) {
        sessionStorage.setItem("last_auth_token", authToken);
      }
    } catch (e) {
      console.error("Error storing auth token:", e);
    }
  }, []);
  const { t } = useI18n("common");
  const navigate = useNavigation();
  const { roomId, role } = useParams();
  const [previewPreference] = useUserPreferences(
    UserPreferencesKeys.PREVIEW,
    defaultPreviewPreference
  );
  return (
    <Flex direction="column" css={{ size: "100%" }}>
      <Box css={{ h: "$18", "@md": { h: "$17" } }} data-testid="header">
        <Header isPreview />
      </Box>
      <Flex
        justify="center"
        direction="column"
        align="center"
        css={{ bg: "$background_dim", flex: "1 1 0", position: "relative" }}
      >
        <Text variant="h2" css={{ fontWeight: "$semiBold" }}>
          👋
        </Text>
        <Text
          variant="h4"
          css={{
            color: "$on_surface_high",
            fontWeight: "$semiBold",
            mt: "$12",
          }}
        >
          {t("you_left_room")}
        </Text>
        <Text
          variant="body1"
          css={{
            color: "$on_surface_medium",
            mt: "$8",
            fontWeight: "$regular",
            textAlign: "center",
          }}
        >
          {t("have_nice_day")}
          {previewPreference.name && (
            <Box as="span" css={{ ...textEllipsis(100) }}>
              , {previewPreference.name}
            </Box>
          )}
          !
        </Text>
        <Flex css={{ mt: "$14", gap: "$10", alignItems: "center" }}>
          <Text
            variant="body1"
            css={{ color: "$on_surface_medium", fontWeight: "$regular" }}
          >
            {t("left_by_mistake")}
          </Text>
          <Button
            onClick={() => {
              const searchParams = new URLSearchParams(window.location.search);
              let authToken = searchParams.get("auth_token");
              let queryString = searchParams.toString();
              if (!authToken && sessionStorage.getItem("last_auth_token")) {
                authToken = sessionStorage.getItem("last_auth_token");
                if (authToken) {
                  searchParams.set("auth_token", authToken);
                  queryString = searchParams.toString();
                }
              }
              const suffix = queryString ? `?${queryString}` : '';
              let previewUrl = "/preview/" + roomId;
              if (role) previewUrl += "/" + role;
              navigate(previewUrl + suffix);
              ToastManager.clearAllToast();
            }}
            data-testid="join_again_btn"
          >
            <ExitIcon />
            <Text css={{ ml: "$3", fontWeight: "$semiBold", color: "inherit" }}>
              {t("rejoin")}
            </Text>
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default PostLeave;
